// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-list[data-v-685f39da] {\n  background-color: white;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  margin-right: 5px;\n}\n.form-group[data-v-685f39da] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.selected-font[data-v-685f39da] {\n  font-size: 12px;\n  color: var(--bs-gray-500);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
